import React from 'react'
import Page from './Page'

interface LoaderProps {
  page?: boolean
}

export default function Loader({page}: LoaderProps) {
  const content = (
    <div className="w-100 py-5 d-flex justify-content-center">
      <div className="spinner-border text-primary" role="status">
        <span className="sr-only">Loading...</span>
      </div>
    </div>
  )

  if (page) {
    return <Page>{content}</Page>
  }
  return content
}
